import { useLocation, useNavigate } from "react-router-dom";
import { useCallback } from "react";

interface PageClickEvent {
  selected: number;
}
type SearchParamValue = string | number | boolean | null | undefined;

const useFilter = () => {
  const { search, pathname } = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(search);

  const searchAll: string = search;
  const subSearch: string = search ? `&${search.substring(1)}` : "";

  const handleParamsAdd = useCallback(
    (name: any, value: string | number | boolean) => {
      searchParams.set(name, String(value));
      const newUrl = `${pathname}?${searchParams.toString()}`;
      navigate(newUrl);
    },
    [navigate, pathname, searchParams],
  );

  const handleParamsRemove = useCallback(
    (name: any) => {
      searchParams.delete(name);
      const newUrl = `${pathname}?${searchParams.toString()}`;
      navigate(newUrl);
    },
    [navigate, pathname, searchParams],
  );

  const handleParamsDeleteAll = useCallback(() => {
    navigate(pathname);
  }, [navigate, pathname]);

  // const handlePaginationClick = useCallback(
  //   (event: PageClickEvent) => {
  //     const newPage = (event.selected + 1).toString();
  //     handleParamsAdd("Start", newPage);
  //   },
  //   [handleParamsAdd]
  // );
  const handlePaginationClick = useCallback(
    (event: PageClickEvent) => {
      const newPage = (event.selected + 1).toString();
      const count = localStorage.getItem("paginationCount") || "10";
      handleParamsAdd("Start", newPage);
      handleParamsAdd("Count", count);
    },
    [handleParamsAdd],
  );

  const handleParamsRemoveMultiple = useCallback(
    (names: string[]) => {
      names.forEach((name) => searchParams.delete(name));
      const newUrl = `${pathname}?${searchParams.toString()}`;
      navigate(newUrl);
    },
    [navigate, pathname, searchParams],
  );

 const navigateWithCurrentParams = useCallback(() => {
   const paramsString = searchParams.toString();

   navigate(paramsString ? `${pathname}?${paramsString}` : pathname);
 }, [navigate, pathname, searchParams]);
 
 const handleParamsUpdate = useCallback(
   (values: Record<string, SearchParamValue>) => {
     Object.entries(values).forEach(([name, value]) => {
       if (value === null || value === undefined || value === "") {
         searchParams.delete(name);
       } else {
         searchParams.set(name, String(value));
       }
     });

     navigateWithCurrentParams();
   },
   [navigateWithCurrentParams, searchParams],
 );

  return {
    searchParams,
    searchAll,
    subSearch,
    handlePaginationClick,
    handleParamsAdd,
    handleParamsRemove,
    handleParamsRemoveMultiple,
    handleParamsDeleteAll,
    handleParamsUpdate,
  };
};
export default useFilter;
